import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { QueryLoadingState } from '@globalconnect/query';
import { Observable, Subject, takeUntil } from 'rxjs';
import { InstallationReportingV2Service } from '../../../../installation-reporting-app/service/sdu/installation-reporting-v2.service';
import {
  InstallationReportOrderDetail,
  InstallationReportResponseV2,
} from '../../../../shared/installation-report-content-v2/installation-report-content-entities';
import { isTopLevelDomainFI } from '../../../../shared/util/deploy-helper';
import {
  finlandColumns,
  swedenColumns,
} from '../../orders-overview-modal/orders-overview-table/orders-overview-columns';
import { MultiPointModalData } from '../../report-modal.service';

@Component({
  selector: 'app-hc-wrapper',
  templateUrl: './hc-wrapper.component.html',
  styleUrl: './hc-wrapper.component.scss',
  standalone: false,
})
export class HcWrapperComponent implements OnInit, OnDestroy {
  private readonly installationReportingServiceV2 = inject(
    InstallationReportingV2Service,
  );

  @Input() ifs: string;
  @Input() multiPointData: MultiPointModalData;
  @Output() dismiss = new EventEmitter();

  deliveryItems$: Observable<
    QueryLoadingState<InstallationReportOrderDetail[]>
  >;
  savedInstallationReportsResponse$: Observable<
    QueryLoadingState<InstallationReportResponseV2[]>
  >;

  cancelSubs$ = new Subject<void>();

  isDownloading = false;
  filterText = '';
  pageSize = 10;

  isDeliveryPortalFI: boolean = isTopLevelDomainFI();
  currentDomainColumns = this.isDeliveryPortalFI
    ? finlandColumns
    : swedenColumns;

  filterFields = [
    'orderDetail.locationInformation.streetName',
    'orderDetail.locationInformation.city',
    'orderDetail.contactInformation.firstName',
    'orderDetail.contactInformation.lastName',
  ];

  ngOnInit(): void {
    this.getDeliveryItems();
    this.getSavedInstallationReportsResponse$();
  }

  ngOnDestroy(): void {
    this.cancelSubs$.next();
    this.cancelSubs$.complete();
  }

  getDeliveryItems() {
    this.deliveryItems$ = this.installationReportingServiceV2
      .getDeliveryItems$(this.ifs)
      .pipe(takeUntil(this.cancelSubs$));
  }

  getSavedInstallationReportsResponse$() {
    this.savedInstallationReportsResponse$ = this.installationReportingServiceV2
      .getAllInstallationReportsForProject$(this.ifs)
      .pipe(takeUntil(this.cancelSubs$));
  }

  closeModal() {
    this.dismiss.emit();
  }
}
